import { useRouter } from "next/router";
import React, { useContext, useRef, useState, useTransition } from "react";
import { useForm } from "react-hook-form";
import Heading from "../../components/Heading";
import offersModel from "../../models/offers.model";

import helper from "../../lib/helper";
import _ from "lodash";
import Link from "next/link";
import { Card } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [minTime, setMinTime] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  const ValuePiece = Date | null;
  const Value = ValuePiece | [ValuePiece, ValuePiece];
  const editorRef = useRef(null);
  const router = useRouter();
  const {
    register,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
  } = useForm();

  const onSubmit = handleSubmit(async (data, event) => {
    console.log("errorrs", errors);
    const formData = new FormData(event.target);
    // formData.set("content", editorRef.current.getContent());
    await offersModel
      .create(formData)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message, "success");
        router.push("/offers");
      })
      .catch((error) => {
        console.log(error.response?.data?.errors);
        helper.sweetalert.toast(error.response?.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title="Create offers" showLoader={showLoader}>
        <Link className="btn btn-primary btn-sm" href={`/offers`}>
          <i className="bi bi-list" /> List
        </Link>
      </Heading>
      <form onSubmit={onSubmit} className="container-fluid">
        <div className="card">
          <div className="card-header">Offer Creation Form</div>
          <div className="card-body g-3">
            <div className="row">
              <div className="col-md-6">
                <div className="col-md-12">
                  <label className="form-label">Title</label>
                  <input
                    placeholder="Enter coupon title"
                    type="text"
                    className={`form-control ${errors?.title && "is-invalid"}`}
                    {...register("title", {
                      required: "Title is required",
                    })}
                  />
                  <div className="invalid-feedback">
                    {errors.title && errors.message}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Discount-code</label>
                    <input
                      placeholder="Enter coupon code"
                      type="text"
                      className={`form-control ${
                        errors?.slug && "is-invalid"
                      } text-uppercase`}
                      {...register("code", {
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors.discount_code && errors.discount_code.message}
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-2">
                  <label className="form-label mt-12">Discount-type:-</label>

                  <input
                    placeholder="Enter discount type"
                    type="radio"
                    name="discount_type"
                    value="fixed"
                    className={`${
                      errors?.name && "is-invalid"
                    } form-check-input mx-2`}
                    {...register("discount_type", {
                      required: "Discount_type is required",
                    })}
                  />
                  <label className="form-check-label">Fixed</label>

                  <input
                    placeholder="Enter collection name"
                    // defaultChecked
                    type="radio"
                    name="discount_type"
                    value="percentage"
                    className={`${
                      errors?.name && "is-invalid"
                    } form-check-input mx-2`}
                    {...register("discount_type", {
                      required: "Discount_type is required",
                    })}
                  />
                  <label className="form-check-label">Percentage</label>
                  <div className="invalid-feedback">
                    {errors.name && errors.message}
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="form-label">Discount-value</label>
                  <input
                    placeholder="Enter Discount value"
                    type="text"
                    className={`form-control ${
                      errors?.discount_value && "is-invalid"
                    }`}
                    {...register("discount_value")}
                  />
                  <div className="invalid-feedback">
                    {errors.discount_value && errors.discount_value.message}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Condition</label>
                    <input
                      placeholder="Enter Condition"
                      type="text"
                      className={`form-control ${errors?.slug && "is-invalid"}`}
                      {...register("slug")}
                    />
                    <div className="invalid-feedback">
                      {errors.slug && errors.slug.message}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">Minimum_amount</label>
                    <input
                      placeholder="Enter Minimum amount"
                      type="text"
                      className={`form-control ${
                        errors?.minimum_amount && "is-invalid"
                      }`}
                      {...register("minimum_amount", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors.minimum_amount && errors.minimum_amount.message}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Maximum_discount</label>
                    <input
                      placeholder="Enter Maximum amount"
                      type="text"
                      className={`form-control ${
                        errors?.max_discount && "is-invalid"
                      }`}
                      {...register("max_discount", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors.max_discount && errors.max_discount.message}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <label className="form-label">User_type:-</label>

                  <input
                    placeholder="Enter collection name"
                    type="radio"
                    name="user_type"
                    value="first_user"
                    className={`${
                      errors?.name && "is-invalid"
                    } form-check-input mx-2`}
                    {...register("user_type", {
                      required: "User_type is required",
                    })}
                  />
                  <label className="form-check-label">First-user</label>

                  <input
                    placeholder="Enter collection name"
                    // defaultChecked
                    type="radio"
                    name="user_type"
                    value="all"
                    className={`${
                      errors?.name && "is-invalid"
                    } form-check-input mx-2`}
                    {...register("user_type", {
                      required: "User_type is required",
                    })}
                  />
                  <label className="form-check-label">All</label>
                  <div className="invalid-feedback">
                    {errors.name && errors.message}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-md-6">
                    <label className="form-label">
                      Select start date <span className="text-danger"></span>
                    </label>
                    <DatePicker
                      selected={startDate}
                      dateFormat={"YYYY-MM-dd HH:mm"}
                      minDate={new Date()}
                      placeholderText="YYYY-MM-dd"
                      onChange={(date) => {
                        setStartDate(date);
                      }}
                      className="form-control"
                      name="start_date"
                      showTimeSelect
                    />
                    <div className="invalid-feedback">
                      {errors.date && errors.date.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Select end date <span className="text-danger"></span>
                    </label>
                    <DatePicker
                      selected={endDate}
                      dateFormat={"YYYY-MM-dd HH:mm"}
                      minDate={new Date()}
                      placeholderText="YYYY-MM-dd"
                      onChange={(date) => {
                        setEndDate(date);
                      }}
                      className="form-control"
                      name="end_date"
                      showTimeSelect
                    />
                    <div className="invalid-feedback">
                      {errors.date && errors.date.message}
                    </div>
                  </div>
                  <div className="invalid-feedback">
                    {errors.date && errors.date.message}
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <label className="form-label">Status</label>
                  <select
                    id="inputState"
                    className={`form-select ${
                      errors?.banner_id && "is-invalid"
                    }`}
                    {...register("status", { required: true })}
                  >
                    <option value="active">Active</option>
                    <option value="deactive">Deactive</option>
                    <option value="public">Public</option>
                  </select>
                  <div className="invalid-feedback">
                    {errors.status && errors.status.message}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <textarea
                      rows={11}
                      placeholder="Enter description"
                      type="text"
                      className={`form-control ${
                        errors?.description && "is-invalid"
                      } `}
                      {...register("description", {
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors.description && errors.description.message}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label mt-2">
                      Terms & conditions
                    </label>
                    <textarea
                      rows={11}
                      placeholder="Enter terms & conditions"
                      type="text"
                      className={`form-control ${
                        errors?.terms_and_condition && "is-invalid"
                      } `}
                      {...register("terms_and_condition", {
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors.terms_and_condition &&
                        errors.terms_and_condition.message}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button type="submit" className="btn btn-primary float-end">
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Page;
